import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { getVirtualSessionStats, VirtualSessionStats } from "api/virtualsessions";
import i18n from "../i18n";

// prop types
interface StreamingStatsTabProps {
    bookingId: string | null,
}

// streaming stats tab in detail dialog
const StreamingStatsTab = ({ bookingId }: StreamingStatsTabProps) => {
    // ui state
    const [streamingStats, setStreamingStats] = useState<VirtualSessionStats>();

    // fetch stats
    const fetchStats = async () => setStreamingStats(await getVirtualSessionStats({ bookingId: bookingId! }));
    useEffect(() => { if (bookingId) fetchStats(); }, [bookingId]);

    // render row
    const renderRow = (label: string, content: React.ReactNode) => (
        <>
            <Grid item xs={6}>
                <Typography>{label}</Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography>{content}</Typography>
            </Grid>
        </>
    );

    // render
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h6">{i18n.streamingStats}</Typography>
            </Grid>
            {renderRow(i18n.numConnectionStarts, streamingStats?.numConnectionStarts)}
            {renderRow(i18n.numUniqueViewers, streamingStats?.numUniqueViewers)}
            {renderRow(i18n.numMaxViewers, streamingStats?.numMaxViewers)}
            {renderRow(i18n.averageTimeWatchedSeconds, `${((streamingStats?.averageTimeWatchedSeconds || 0) / 60).toFixed(2)} min`)}
            {renderRow(i18n.connectionShares30s, `${Math.round((streamingStats?.connectionShares.after30s || 0) * 100)} %`)}
            {renderRow(i18n.connectionShares5min, `${Math.round((streamingStats?.connectionShares.after5min || 0) * 100)} %`)}
            {renderRow(i18n.numPlaybackStarts, streamingStats?.numPlaybackStarts)}
            {renderRow(i18n.reactions, Object.entries(streamingStats?.reactions || {}).map(([r, c]) => `${r} ${c}`).join(", ") || "0")}
        </Grid>
    );
};

export default StreamingStatsTab;
